<template>
  <div>
    <PlaceholderPage 
      title="Notifikasi" 
      :icon="['fas', 'bell']"
      message="Halaman ini akan menampilkan semua notifikasi dan pemberitahuan terkait aktivitas akun Anda, termasuk pembaruan buku dari penulis favorit dan interaksi sosial."
    />
  </div>
</template>

<script>
import PlaceholderPage from '@/components/PlaceholderPage.vue'

export default {
  name: 'Notifications',
  components: {
    PlaceholderPage
  }
}
</script>